import { type FC, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import BaseLayout from '@/base/Layout';
import BaseLayoutBody from '@/base/Layout/Body';
import {
  UiDivider,
  UiHStack,
  UiStack,
  UiText,
  uiStyles,
  UiVStack,
  UiIconDotsNine,
  UiSimpleGrid, UiBox, UiIconCurrencyCircleDollar
} from '@/lib/ui';
import { RouteParams } from '@/app/pages';
// import Filter from './Filter';
import BaseBreadcrumbBar, { type BaseBreadcrumbBarNode } from '@/base/BreadcrumbBar';
import SmartWindow from '@/base/Layout/SmartWindow';
import SideNav from '@/account/component/Layout/SideNav';
import SwitchApp from '@/account/component/Layout/SwitchApp';
import BaseAppAccountCard from '@/base/App/AccountCard';
import BaseAppListDrawerButton from '@/base/App/ListDrawerButton';
import PaymentTable from './PaymentTable';
import CurrencyTag from '@/account/component/CurrencyTag';

const Bill: FC = () => {
  const [isSmartWindowVisible, setIsSmartWindowVisible] = useState(false);
  const breadcrumbNodes = useMemo<BaseBreadcrumbBarNode[]>(
    () => {
      return [
        { label: 'Dashboard' },
        { label: 'Bill' }
      ];
    },
    []
  );

  // const onSmartButtonClick = () => {
  //   setIsSmartWindowVisible(!isSmartWindowVisible);
  // };

  return (
    <>
      <BaseLayout
        smartWindow={(<SmartWindow />)}
        sideMenu={(<SideNav activeNodes={['subscription', 'billing']} />)}
        appSwitch={(<BaseAppListDrawerButton currentApp={<BaseAppAccountCard showDescription={false} />} currentAppName={'account'} />)}
      >
        <BaseLayoutBody
          isStandalone={false}
          // breadcrumbNodes={breadcrumbNodes}
        >
          <UiStack flexGrow={1} spacing={0} alignItems={'stretch'}>
            <UiStack justifyContent={'flex-start'} alignItems={'flex-end'} pb={8}>
              <CurrencyTag currency={'AUD'} />
            </UiStack>
            {/* <UiStack> */}
            {/*  <UiText variant={'title'}>Next payment</UiText> */}
            {/*  <UiSimpleGrid columns={4} spacing={8} bgColor={'#fff'} borderRadius={uiStyles.borderRadius} p={8}> */}
            {/*    <UiStack> */}
            {/*      <UiText variant={'body2'} color={'text.secondary'}>Invoice number</UiText> */}
            {/*      <UiText variant={'title'}>11202311</UiText> */}
            {/*    </UiStack> */}
            {/*    <UiStack> */}
            {/*      <UiText variant={'body2'} color={'text.secondary'}>Invoice date</UiText> */}
            {/*      <UiText variant={'title'}>2023/11/01</UiText> */}
            {/*    </UiStack> */}
            {/*    <UiStack> */}
            {/*      <UiText variant={'body2'} color={'text.secondary'}>Payment due date</UiText> */}
            {/*      <UiText variant={'title'}>2023/11/15</UiText> */}
            {/*    </UiStack> */}
            {/*    <UiStack> */}
            {/*      <UiText variant={'body2'} color={'text.secondary'}>Estimated amount</UiText> */}
            {/*      <UiText variant={'title'}>$13,000</UiText> */}
            {/*    </UiStack> */}
            {/*  </UiSimpleGrid> */}
            {/* </UiStack> */}
            {/* <UiStack py={12}> */}
            {/*  <UiDivider borderColor={'gray.300'} /> */}
            {/* </UiStack> */}
            <UiStack>
              <PaymentTable />
            </UiStack>
          </UiStack>
        </BaseLayoutBody>
      </BaseLayout>
      {/* <Filter
        isOpen={showFilter}
        onClose={() => {setShowFilter(false)}}
      /> */}
    </>
  );
};

export default Bill;
